<template>
	<div class="card">
		<h1>{{$t('PlayerMatch')}}</h1>
		<div class="p-grid">
			<div :class="[ chatVisualitzation ? 'p-col-4' : 'p-col-2']">
				<div class="box">
					<span class="center">{{$t('Role')}}</span>
					<i class="pi pi-check-circle margin" :style="{ fontSize: fontSize, color: roleColor, opacity: roleOpacity }" />
				</div>
			</div>
			<div :class="[ chatVisualitzation ? 'p-col-4' : 'p-col-2']">
				<div class="box">
					<span class="center">{{$t('address')}}</span>
					<i class="pi pi-check-circle margin" :style="{ fontSize: fontSize, color: addressColor, opacity: addressOpacity }" />
				</div>
			</div>
			<div :class="[ chatVisualitzation ? 'p-col-4' : 'p-col-2']">
				<div class="box">
					<span class="center">{{$t('Age')}}</span>
					<i class="pi pi-check-circle margin" :style="{ fontSize: fontSize, color: ageColor, opacity: ageOpacity }" />
				</div>
			</div>
			<div v-if="chatVisualitzation" class="break"></div>
			<div :class="[ chatVisualitzation ? 'p-col-4' : 'p-col-2']">
				<div class="box">
					<span class="center">{{$t('Category')}}</span>
					<i class="pi pi-check-circle margin" :style="{ fontSize: fontSize, color: categoryColor, opacity: categoryOpacity }" />
				</div>
			</div>
			<div :class="[ chatVisualitzation ? 'p-col-4' : 'p-col-2']">
				<div class="box">
					<span class="center">{{$t('Video')}}</span>
					<i class="pi pi-check-circle margin" :style="{ fontSize: fontSize, color: videoColor, opacity: videoOpacity }" />
				</div>
			</div>
			<div :class="[ chatVisualitzation ? 'p-col-4' : 'p-col-2']">
				<div class="box">
					<span class="center">TM</span>
					<i class="pi pi-check-circle margin" :style="{ fontSize: fontSize, color: TMColor, opacity: TMOpacity }" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import RequestService from "@/service/RequestService";

export default {
	components: {},
	props: ["requestId", "playerId", "chatVisualitzation"],
	data: function () {
		return {
			roleOpacity: 0,
			addressOpacity: 0,
			ageOpacity: 0,
			categoryOpacity: 0,
			videoOpacity: 0,
			TMOpacity: 0,
			fontSize: "2em",
			roleColor: "green",
			addressColor: "green",
			ageColor: "green",
			categoryColor: "green",
			videoColor: "green",
			TMColor: "green",
			playerMatch: {
				matchRole: 100,
				matchAddress: 90,
				matchAge: 80,
				matchCategory: 70,
				matchVideo: 60,
				matchTM: 0,
			},
			chatVisualitzation: false,
		};
	},
	requestService: null,
	created() {
		this.requestService = new RequestService();

		let self = this;
		this.requestService
			.calculatePlayerMatch(this.requestId, this.playerId)
			.then(
				(res) => {
					self.playerMatch = res.data;
					self.formatChecks();
				},
				function (err) {
					self.$toast.add({
						severity: "error",
						summary: self.$t("errorMessage"),
						detail: self.$t("Error"),
						life: 3000,
					});
				}
			);
	},
	methods: {
		getOpacity(value) {
			switch (value) {
				case 100:
					return 1;
				case 90:
					return 0.7;
				case 80:
					return 0.5;
				case 70:
					return 0.3;
				case 60:
					return 0.1;
				default:
					return 0;
			}
		},
		formatChecks() {
			this.roleOpacity = this.getOpacity(this.playerMatch.matchRole);
			if (this.roleOpacity == 0) {
				this.roleColor = "grey";
				this.roleOpacity = 1;
			}
			this.addressOpacity = this.getOpacity(
				this.playerMatch.matchAddress
			);
			if (this.addressOpacity == 0) {
				this.addressColor = "grey";
				this.addressOpacity = 1;
			}
			this.ageOpacity = this.getOpacity(this.playerMatch.matchAge);
			if (this.ageOpacity == 0) {
				this.ageColor = "grey";
				this.ageOpacity = 1;
			}
			this.categoryOpacity = this.getOpacity(
				this.playerMatch.matchCategory
			);
			if (this.categoryOpacity == 0) {
				this.categoryColor = "grey";
				this.categoryOpacity = 1;
			}
			this.videoOpacity = this.getOpacity(this.playerMatch.matchVideo);
			if (this.videoOpacity == 0) {
				this.videoColor = "grey";
				this.videoOpacity = 1;
			}
			this.TMOpacity = this.getOpacity(this.playerMatch.matchTM);
			if (this.TMOpacity == 0) {
				this.TMColor = "grey";
				this.TMOpacity = 1;
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.box {
	border-radius: 25px;
	border: 1px solid #b3c2ca;
	text-align: center;
	padding: 5px;
}

.center {
	vertical-align: super;
}

.margin {
	margin-left: 5px;
}

.break {
	flex-basis: 100%;
	height: 0;
}
</style>